module.exports = __webpack_public_path__ + "collector-edition-mobile.png";